import { common } from './common.icons';

export const IconArrowUp = ({ className = '', style = {}, ...rest }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`icon-arrow-up ${common.classes} ${className}`}
      {...rest}
      style={{ ...common.styles, ...style }}
      viewBox="0 0 12 8"
    >
      <path d="M1.41 7.91L6 3.33L10.59 7.91L12 6.5L6 0.5L0 6.5L1.41 7.91Z" fill="currentColor" />
    </svg>
  );
};
